import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { Reveal, Section } from '@/components/ui'
import { WorkTogetherCta } from '@/features/cta'
import {
  Distinctions,
  References,
  ResearchInterests,
  ThesisList,
} from '@/features/research'
import { SocialPanels } from '@/features/social'

/**
 * Research, distinctions and references.
 *
 * This replaces the template's blog: the work that matters here is academic,
 * not editorial.
 */
export const ResearchPage = () => {
  const { site } = useContent()
  useDocumentMeta({
    title: `Research - ${site.name}`,
    description:
      'Thesis work in cloud deployment, embedded systems and wireless communications, plus distinctions and academic references.',
  })

  return (
    <>
      <Section>
        <ThesisList />
      </Section>

      <Reveal>
        <Section>
          <ResearchInterests />
        </Section>
      </Reveal>

      <Reveal>
        <Section>
          <Distinctions />
        </Section>
      </Reveal>

      <Reveal>
        <Section>
          <References />
        </Section>
      </Reveal>

      <Reveal>
        <WorkTogetherCta />
      </Reveal>

      <Reveal>
        <SocialPanels />
      </Reveal>
    </>
  )
}
